import { useMemo } from 'react'
import { collection, query, where } from 'firebase/firestore'
import { db } from '../lib/firebase'
import { useBatchedSubscriptions } from './useBatchedSubscriptions'
import type { EventArtistInterest } from '../types'

const EMPTY_RECORD: Record<string, string[]> = {}

/**
 * artistId → the given users who hearted it on this event's lineup. Pass an
 * empty list until the facepiles are on screen. Friends' app-wide follows are
 * `useFriendArtistInterests`.
 */
export function useFriendEventArtistInterests(userIds: string[], eventId: string) {
  const { rows, loading } = useBatchedSubscriptions<EventArtistInterest>(
    userIds,
    batch =>
      query(
        collection(db, 'eventArtistInterests'),
        where('eventId', '==', eventId),
        where('userId', 'in', batch),
      ),
    d => d.data() as EventArtistInterest,
    { queryKey: eventId },
  )

  const artistUserIds = useMemo(() => {
    if (rows.length === 0) return EMPTY_RECORD
    const map: Record<string, string[]> = {}
    for (const i of rows) (map[i.artistId] ??= []).push(i.userId)
    return map
  }, [rows])

  return { artistUserIds, loading }
}
